import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';

import { AppComponent } from './app.component';
import { AppCoreModule } from './core/app-core.module';
import { AppStoreModule } from './store/app-store.module';
import { FormEngineModule } from './form/form-engine.module';
import { LayoutModule } from './layout/layout.module';
import { PageModule } from './page/page.module';
import { ComponentModule } from './component/component.module';

import { routes } from './app.route';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig } from "ng2-currency-mask/src/currency-mask.config";
import {TabsModule} from 'ngx-tabset';


export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: false,
  allowZero: false,
  decimal: ".",
  precision: 2,
  prefix: "",
  suffix: "",
  thousands: ","
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes, { useHash: false }),
    CommonModule,
    TabsModule.forRoot(),


    AppCoreModule,
    AppStoreModule,
    FormEngineModule,
    LayoutModule,
    PageModule,
    ComponentModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule{}



// WEBPACK FOOTER //
// ./src/app/app.module.ts